import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import controllerAusencias from "../ausencias/duck";
import { useSelector, useDispatch } from "react-redux";
import { responseSelector } from "../utils/helpers/selectors";
import { logger, thousandSeparator } from "../utils/utils";
import moment from "moment";
import config from "../config";
import queryString from "query-string";

const { Select2, Date, DateTime, Text } = Inputs;

function SegurosList({ history, match }) {
  const dispatch = useDispatch();

  const modelSeguros = useSelector((state) => state.segurosByLocal);

  const [seguros, setSeguros] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    const data = modelSeguros?.data?.data;
    const error = modelSeguros?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckSegurosByLocal.actions.clear());
    }
    if (data) {
      setSeguros(data.data.items);
      setTotalResults(data.data.total);

      dispatch(controller.duckSegurosByLocal.actions.clear());
    }
  }, [modelSeguros]);

  useEffect(() => {
    dispatch(
      controller.getSegurosByLocalThunk(match.params.organizacion, 1, pageSize)
    );
  }, []);

  function handlePage(page) {
    setActivePage(page);
    setSeguros([]);
    dispatch(
      controller.getSegurosByLocalThunk(
        match.params.organizacion,
        page + 1,
        pageSize
      )
    );
  }

  return (
    <Content
      title="Seguros"
      subTitle="Seguros"
      browserTitle="Seguros"
      show={false}
    >
      <Row>
        <Col md="8">
          <Box title="Seguros">
            <Button
              type="primary"
              text="Agregar"
              pullRight={true}
              onClick={() =>
                history.push(`/nuevoSeguro/${match.params.organizacion}`)
              }
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
            {seguros && seguros.length > 0 ? (
              <SimpleTable
                hover={true}
                data={seguros.map((row, index) => {
                  return {
                    nombre: row.nombre,
                    estado: row.estado,
                    editar: (
                      <Button
                        type="primary"
                        text="Editar"
                        onClick={() => history.push(`/editSeguro/${row._id}`)}
                      />
                    ),
                  };
                })}
                columns={[
                  { title: "Nombre", data: "nombre" },
                  { title: "Estado", data: "estado" },
                  { title: "Editar", data: "editar" },
                ]}
              />
            ) : (
              <h4>No se han encontrado seguros</h4>
            )}
            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default SegurosList;
